import { fetcher } from '@commenda/utils';
import { FileFolderCategory } from '@prisma/client';

export interface TCreateFileFolderBody {
  corporationId: number;
  category?: FileFolderCategory;
  name?: string;
}

export default async function createFileFolder({
  body,
  nextAuthToken,
}: {
  body: TCreateFileFolderBody;
  nextAuthToken: string;
}): Promise<Response> {
  const res = await fetcher(
    'fileFolder',
    {
      method: 'POST',
      body,
    },
    nextAuthToken
  );
  return res;
}
